// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bhr_tr","LeftMenu__link":"ir_b bhr_vt bhr_a bhr_rc","LeftMenu__link__icon":"ir_c"};